import { Checkbox } from "primereact/checkbox";
import localeText from "../../../locale";
import Termos from "../../../assets/static/Termos.pdf";
import ReferralField from "./ReferralField";
import InviteCouponField from "./InviteCouponField.js";

const TermsAndMarketing = ({
  terms,
  setTerms,
  marketingEmail,
  setMarketingEmail,
  hasReferral,
  setHasReferral,
  referralUsername,
  setReferralUsername,
  referralIconSpinner,
  setReferralIconSpinner,
  referralRef,
  onBlurReferral,
  hasInviteCoupon,
  setHasInviteCoupon,
  inviteCoupon,
  setInviteCoupon,
  loading,
}) => {
  return (
    <>
      <ReferralField
        hasReferral={hasReferral}
        setHasReferral={setHasReferral}
        referralUsername={referralUsername}
        setReferralUsername={setReferralUsername}
        referralIconSpinner={referralIconSpinner}
        setReferralIconSpinner={setReferralIconSpinner}
        referralRef={referralRef}
        onBlurReferral={onBlurReferral}
        loading={loading}
      />

      <InviteCouponField
        hasInviteCoupon={hasInviteCoupon}
        setHasInviteCoupon={setHasInviteCoupon}
        inviteCoupon={inviteCoupon}
        setInviteCoupon={setInviteCoupon}
        loading={loading}
      />

      <div className="field">
        <div className="flex align-items-start gap-2">
          <Checkbox
            name="terms"
            onChange={(e) => setTerms(e.checked)}
            checked={terms}
            disabled={loading}
          />
          <label htmlFor="terms" className="text-sm" style={{ color: "#344563" }}>
            {localeText("iAccept")}{" "}
            <a
              style={{ color: "#344563", textDecoration: "none"}}
              href={Termos}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              {localeText("termsAndConditions")}
            </a>{" "}
            *
          </label>
        </div>
      </div>

      <div className="field">
        <div className="flex align-items-start gap-2">
          <Checkbox
            name="marketingEmail"
            onChange={(e) => setMarketingEmail(e.checked)}
            checked={marketingEmail}
            disabled={loading}
          />
          <label htmlFor="marketingEmail" className="text-sm" style={{ color: "#344563" }}>
            {localeText("marketingEmail")}
          </label>
        </div>
      </div>
    </>
  );
};

export default TermsAndMarketing;
